import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'
import UserAddEditModel from './useraddeditmodel-dialog-screen.vue';
import UserImportModel from './userimportmodel-dialog-screen.vue';
import UserListModel from './userlistmodel-list-screen.vue';


export default {
    data: function () {
        return {
            screenKey: "UserListModel",
            loading: false,
            actionLocked: false,
            modelId: this.$route.params.id ?? 0, // Parent Model ID
            model: { },
            
            filter: null,
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'UserName',
                    label: 'User Name',
                    align: 'left',
                    field: row => row.UserName,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: '',
                    isVisible: () => true
                },

            ],
            columnsVisible: ['UserName', 'Actions'],
            dataSource: [],
            selected: [],
            editRowKey: null,
            pagination: {
                sortBy: 'Id',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            applicationResources: null,
            toolTipStates: {},
            localTimezoneOffset: new Date().getTimezoneOffset()
        }
    },

    methods: {
        onClearFilterActionClick() {
            this.filter = null;
        },

        async refreshScreen() {
            this.modelId = this.$route.params.id ?? 0;
            this.selected = [];

            await this.onLoadListDataSource();
        },

        onCreateActionClick() {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: UserAddEditModel,
                parent: this,
                index: 0,
                modelId: 0,
                modelObject: null,
                actionLabel: 'Save',
                actionTitle: 'Create',
                editMode: true
            }).onOk((payload) => {
                this.dataSource.splice(0, 0, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onEditActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: UserAddEditModel,
                parent: this,
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionLabel: 'Save',
                actionTitle: 'Edit',
                editMode: true
            }).onOk((payload) => {
                var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onDeleteActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;
            
            this.$q.dialog({
                title: 'Confirm',
                message: 'Are you sure?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                if (this.onDeleteModelDataSource(rowKey, row)) {
                    var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1);
                }
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onResetPasswordActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
            
            this.$q.dialog({
                title: 'Confirm',
                message: 'Are you sure?',
                cancel: true,
                persistent: true,
                html: true
            }).onOk(() => {
                this.onResetPasswordServerActionDataSource({
                    id: rowKey,
                params: row,
                dialogData: null,
                dialogFiles: null

                });
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onImportUsersActionClick() {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
            
            this.$q.dialog({
                component: UserImportModel,
                parent: this,
                index: 0,
                modelId: 0,
                modelObject: null,
                actionLabel: 'Import Users',
                actionTitle: 'Import',
                editMode: true,
                parentScreenParameters: {
                    Filter: this.filter,
                    SelectedRowIds: this.selected?.map(function (row) { return row.Id; }),
                    LocalTimezoneOffset: this.localTimezoneOffset
                }
            }).onOk((payload) => {
                this.onImportUsersServerActionDataSource({
                    id: this.modelId,
                params: null,
                filter: this.filter,
                localTimezoneOffset: this.localTimezoneOffset,
                selectedRowIds: this.selected.map(function(row){ return row.Id; }),
                dialogData: payload.model,
                dialogFiles: payload.files

                });
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        async onLoadListDataSource() {
            try {
                this.loading = true;
                
                let response = await this.$http.get('/api/ui/users/'.replace('{id}', this.modelId), {  });
                
                if (response.body.Metadata) {
                    this.model = response.body.Metadata;
                    
                    this.dataSource = response.body.Rows;
                } else {
                    this.dataSource = response.body;
                }
                
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onDeleteModelDataSource(id, params) {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/users/{id}', id, params);
                let response = await this.$http.delete(url, {  });
                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onImportUsersServerActionDataSource(params) {
            try {
                this.$q.loading.show({
                    message: 'In progress...'
                });

                let requestBody = {
                    Filter: params.filter,
                    LocalTimezoneOffset: params.localTimezoneOffset,
                    SelectedRowIds: params.selectedRowIds,
                    DialogData: params.dialogData
                };
 
                // Request from list screen toolbar.
                let formData = new FormData();

                formData.append('json', JSON.stringify(requestBody));

                Array.from(params.dialogFiles).map((file, index) => {
                    return formData.append('files', file, file.name);
                });

                let url = this.$prepareServerUrl('/api/ui/users/import', params.id, params.params, null);
                let response = await this.$http.post(url, formData, {  });

                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.$q.loading.hide();
            }
        },

        async onResetPasswordServerActionDataSource(params) {
            try {
                this.$q.loading.show({
                    message: 'In progress...'
                });

                // Request from grid row.
                let url = this.$prepareServerUrl('/api/ui/users/{id}/reset_password', params.id, params.params, null);
                let response = await this.$http.post(url, params.dialogData, {  });

                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.$q.loading.hide();
            }
        },

        
        
    },

    computed: {
        screenTitle: function () {
            return 'Users';
        },

        
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: async function () {
        this.refreshScreen();

    }
}